import { call, select, take } from 'redux-saga/effects';

import selectors from '@elab/core/store/cart/selectors';
import types from '@elab/core/store/cart/types';
import { selectors as configSelectors } from '@elab/core/store/config';
import { deleteUrlParam, getPathname, getSearchParam } from '@elab/core/utils/address';
import { limitativeCheckParam } from '@elab/core/utils/constants';

export function* waitForCartLoading() {
    let isCartLoading = yield select(selectors.isLoading);
    while (isCartLoading) {
        yield take(types.SET_LOADING);
        isCartLoading = yield select(selectors.isLoading);
    }
}

export const hasLimitationBrands = (entries = []) =>
    entries.length
        ? !!entries.find(item => item.product.masterBrand && item.product.masterBrand.limitative)
        : false;

export function* canLimitativeOnThisPage() {
    const limitativeChecked = yield call(removeUrlParam);

    if (limitativeChecked) {
        return false;
    }
    const acceptedLimitativeRoutes = yield select(configSelectors.getAcceptedLimitativeRoutes);
    return acceptedLimitativeRoutes.test(getPathname());
}

export function removeUrlParam() {
    // we use a get param to maintain state after login page redirect
    if (getSearchParam(limitativeCheckParam)) {
        deleteUrlParam(limitativeCheckParam);
        return true;
    }

    return false;
}
